import { defaultSettings } from '@/constants/optima';

const defaultThreshold = { weight: 5000, volume: 400 };
const defaultFloor1 = { weight: 3000, volume: 363 };
const defaultFloor2 = { weight: 90, volume: 90 };
const defaultCaseCapacity = { weight: 5, volume: 2 };
const getPicklistKey = picklist => String(
  (picklist && (picklist.fixed_s_no || picklist.s_no || (picklist.consignee && picklist.consignee.ref_id))) || '',
);

const mutation = {
  setLoading(state, status) {
    state.isLoading = status;
  },
  emptyIndent(state, data) {
    state.indents = data;
  },
  setIndents(state, data) {
    const result = (state.filter.page > 1) ? state.indents.concat(data) : data;
    state.indents = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setSelectAll(state, data) {
    state.selectAll = data;
    if (!data) {
      state.indentAggregateTotals = null;
    }
  },
  selectedIndents(state, data) {
    state.selectedIndentMap = data;
  },
  indentIdWiseData(state, data) {
    state.indentIdWiseData = data;
  },
  setUploadDetails(state, data) {
    state.uploadDetails = data;
  },

  setGatesMap(state, data) {
    state.gatesMap = { ...data };
  },
  setRejectedCount(state, data) {
    state.uploadDetails.invalid_count = data.rejectCount;
    state.uploadDetails.rejectedMaterialsPath = data.rejectionXlsPath;
  },
  paginationCheck(state, status) {
    state.isPaginating = status;
  },
  setSummary(state, data) {
    state.notCombineConisgnee = [];
    state.holdConsigneesWithDelivery = [];
    state.summaryConsignees = data.consigneeList;
    state.summaryDeliveryNos = data.summary.map(consignee => ({ consignee_id: consignee.consignee_id, delivery_nos: consignee.delivery_nos.map(delivery => ({ delivery_no: delivery, checked: false })) }));
  },
  isIndentUpdating(state, status) {
    state.isUpdating = status;
  },
  updateIndent(state, data) {
    state.indentDetails = data;
  },
  setIndentIds(state, data) {
    state.editIndentIds = data;
  },
  editIndents(state, data) {
    state.editIndents = data;
  },
  deleteIndents(state, ids) {
    state.indents = state.indents.filter(indent => ids.indexOf(indent.id) === -1);

    if (state.editIndents.length) {
      state.editIndents = state.editIndents.filter(indent => ids.indexOf(indent.id) === -1);
    }
  },
  setMaterials(state, data) {
    state.consigneeMaterials = data;
  },
  setOrderDetails(state, data) {
    state.orderDetails = data;
  },
  setIndent(state, data) {
    state.indent = data;
  },
  setSetting(state, data) {
    const depotSettings = { ...data.optima_configuration };
    if (!depotSettings.pickup_threshold) {
      depotSettings.pickup_threshold = { ...defaultThreshold };
    }
    if (!depotSettings.floor_one) {
      depotSettings.floor_one = { ...defaultFloor1 };
    }

    if (!depotSettings.floor_two) {
      depotSettings.floor_two = { ...defaultFloor2 };
    }
    depotSettings.minimum_additional_drop_threshold = {
      weight: depotSettings.minimum_additional_drop_threshold?.weight || 0,
      volume: depotSettings.minimum_additional_drop_threshold?.volume || 0,
      quantity: depotSettings.minimum_additional_drop_threshold?.quantity || 0,
    };
    if (!depotSettings.gate_pickup_threshold) {
      depotSettings.gate_pickup_threshold = [];
    }
    state.settings = { ...depotSettings };
  },
  setFmsCutoffTime(state, value) {
    state.settings = { ...state.settings, fms_cutoff_time: value };
  },
  makeEmptySetting(state, data) {
    state.settings = { ...data };
  },
  setDefaultSetting(state, data) {
    const depotSettings = data;
    depotSettings.pickup_threshold = { ...defaultThreshold };
    depotSettings.floor_one = { ...defaultFloor1 };
    depotSettings.floor_two = { ...defaultFloor2 };
    depotSettings.minimum_additional_drop_threshold = { weight: 0, volume: 0, quantity: 0 };
    state.settings = { ...depotSettings };
  },
  setMovement(state, Id) {
    state.defaultDepot.movement = Id;
    state.selectedDeliveryDetails = {};
    state.selectedIndentData = {};
  },
  setDeliveryStatus(state, { routeSettings, data, index }) {
    routeSettings.delivery_split_status.forEach((statusObj, i) => {
      if (index === i) {
        statusObj.delivery_status_value = data;
      }
    });
  },
  setCustomParamsName(state, { routeSettings, data, index, type }) {
    routeSettings.custom_params.forEach((statusObj, i) => {
      if (index === i) {
        statusObj.name = data;
        statusObj.type = type;
        if (type === 'boolean') {
          statusObj.value = false;
        }
      }
    });
  },
  setDefaultDepot(state, { depotId, movement }) {
    state.defaultDepot.depot_id = depotId;
    state.defaultDepot.movement = movement;
    state.selectedDeliveryDetails = {};
    state.selectedIndentData = {};
  },
  setVehicles(state, data) {
    const ftlVehicles = data.filter(vehicle => vehicle.vehicle_type === 'FTL');
    state.vehicles = ftlVehicles;
  },
  setPage(state, data) {
    state.filter.page = data;
    if(data === 1) {
      state.selectedDeliveryDetails = {};
      state.selectedIndentData = {};
    }
  },
  setNotCombineList(state, data) {
    state.not_combines = data;
  },
  depotDeliveryList(state, data) {
    let depotIds = [];
    if (data.length) {
      depotIds = data[0].depot_ids;
    }
    state.depotDeliveryList = depotIds;
  },
  isDeliveryPickLoading(state, data) {
    state.isDeliveryPickLoading = data;
  },
  holdConsigneeChange(state, data) {
    if (data.status) {
      const consigneeIndex = state.holdConsigneesWithDelivery.findIndex(consignee => consignee.consignee_id === data.consignee_id);
      if (consigneeIndex !== -1) {
        state.holdConsigneesWithDelivery[consigneeIndex].delivery_nos = data.deliveryNos;
      } else {
        state.holdConsigneesWithDelivery.push({ consignee_id: data.consignee_id, delivery_nos: data.deliveryNos });
      }
    } else {
      const index = state.holdConsigneesWithDelivery.findIndex(consignee => consignee.consignee_id === data.consignee_id);
      if (index !== -1) {
        state.holdConsigneesWithDelivery.splice(index, 1);
        state.holdConsigneesWithDelivery = state.holdConsigneesWithDelivery;
      }
    }
  },
  changeNotCombine(state, data) {
    if (data.status) {
      state.notCombineConisgnee.push(data.consignee_id);
    } else {
      const index = state.notCombineConisgnee.indexOf(data.consignee_id);
      if (index !== -1) {
        state.notCombineConisgnee.splice(index, 1);
        state.notCombineConisgnee = state.notCombineConisgnee;
      }
    }
  },
  holdDeliveryWise(state, data) {
    const consigneeDeliveryNos = [...state.holdConsigneesWithDelivery];
    const index = consigneeDeliveryNos.findIndex(consignee => consignee.consignee_id === data.consignee_id);
    if (index !== -1) {
      const deliveryNumbers = consigneeDeliveryNos[index].delivery_nos;
      const deliveryIndex = deliveryNumbers.findIndex(delivery => delivery.delivery_no === data.number);

      if (deliveryIndex !== -1 && !data.status) {
        deliveryNumbers.splice(deliveryIndex, 1);
        consigneeDeliveryNos[index].delivery_nos = deliveryNumbers;
        if (consigneeDeliveryNos[index].delivery_nos.length === 0) {
          consigneeDeliveryNos.splice(index, 1);
        }
      }
      if (data.status) {
        consigneeDeliveryNos[index].delivery_nos.push({ delivery_no: data.number, checked: false });
      }
    } else {
      consigneeDeliveryNos.push({ consignee_id: data.consignee_id, delivery_nos: [{ delivery_no: data.number, checked: false }] });
    }
    state.holdConsigneesWithDelivery = consigneeDeliveryNos;
  },
  reOptimizeSummary(state, data) {
    state.reOptimize = data;
  },
  setHoldConisgnee(state, data) {
    state.holdConisgnees = data;
  },
  setnotCombineConisgnee(state, data) {
    state.notCombineConisgnee = data;
  },
  setIndentCount(state, data) {
    state.indentCount = data;
  },
  setDeliveryPickStatus(state, data) {
    state.deliveryPickList.status = data;
    state.selectedDeliveryDetails = {};
    state.selectedDeliveryNumber = {};
    state.selectedPicklistMap = {};
    state.selectedPicklistIds = [];
    state.selectedPicklistData = {};
    state.selectedIndentData = {};
  },
  setDeliveryPage(state, data) {
    state.deliveryPickList.page = data;
  },
  setDeliveryNumber(state, data) {
    state.deliveryPickList.delivery_number = data || null;
  },
  depotWiseDeliveryNos(state, data) {
    const result = (state.deliveryPickList.page > 1) ? state.depotWiseDeliveryNos.concat(data) : data;
    state.depotWiseDeliveryNos = result;
    if (data.length) {
      state.deliveryPickList.page += 1;
      state.deliveryNosHasEmpty = false;
    } else {
      state.deliveryNosHasEmpty = true;
    }
  },
  setDeliveryPicklistMeta(state, data) {
    state.deliveryPicklistMeta = data || {};
  },
  setDeliveryProcessedCounts(state, data) {
    state.deliveryProcessedCounts = data;
  },
  setInvalidPath(state, data) {
    state.setInvalidPath = data;
  },
  setOptimaAutoRun(state, data) {
    state.optimaAutoRun = data;
  },
  setOptimaAutoIndent(state, data) {
    state.optimaAutoIndent = data;
  },
  // setSelectedIndents(state, data) { // TODO need to remove after testing
  //   state.selectedIndents = data;
  // },
  resetSelectedIndents(state) {
    const selectedIndentMap = state.selectedIndentMap;
    state.indents.forEach((indent) => {
      selectedIndentMap[indent.id] = false;
    });
    state.selectedIndentMap = selectedIndentMap;
    state.selectAll = false;
    state.indentAggregateTotals = null;
  },
  setSelectedIndentMap(state, data) {
    if (!state.selectAll) {
      state.indentAggregateTotals = null;
    }
    state.selectedIndentMap = data;
  },
  setIndentIdWiseData(state, data) {
    state.indentIdWiseData = data;
  },
  setIndentBucket(state, data) {
    state.indentBucket = data;
  },
  setEmptyRejectionListData(state, data) {
    const result = (state.detailsPage > 1) ? state.optimaRejectionsListData.concat(data) : data;
    state.optimaRejectionsListData = result;
    if (data.length) {
      state.detailsPage += 1;
      state.hasEmpty = false;
    } else {
      state.optimaRejectionsListData = [];
      state.hasEmpty = true;
    }
  },
  addMovement(state, data) {
    let res = false;
    state.movement_list.forEach((element) => {
      if (element.id === data.id) {
        res = true;
      }
    });
    if (!res) {
      state.movement_list.push(data);
    }
  },
  setRejectionListData(state, data) {
    const result = (state.detailsPage > 1) ? state.optimaRejectionsListData.concat(data) : data;
    state.optimaRejectionsListData = result;
    if (data.length) {
      state.detailsPage += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  initialRejectionReset(state) {
    state.detailsPage = 1;
    state.hasEmpty = false;
    state.optimaRejectionsListData = [];
  },
  setOptimaCurrentJobId(state, jobId) {
    state.optimaCurrentJobId = jobId;
  },
  setOptimaCurrentPage(state, page) {
    state.optimaCurrentPage = page;
  },
  setDeliveryPicklist(state, data){
    data.forEach(picklist => {
      const key = getPicklistKey(picklist);
      if (!key) return;
      if (typeof state.selectedPicklistMap[key] === 'undefined') {
        state.selectedPicklistMap[key] = false;
      }
      state.picklistIdsMap[key] = picklist.optima_material_ids;
      if (state.selectedDeliveryNumber[key] && !state.selectedPicklistData[key]) {
        state.selectedPicklistData[key] = picklist;
        if (!state.selectedPicklistIds.includes(key)) {
          state.selectedPicklistIds.push(key);
        }
      }
    });
    let result;
    if (state.filter.page > 1) {
      result = state.deliveryPicklist.concat(data);
      if (state.selectAllPicklistConsignees) {
        state.selectAllPicklistConsignees = false;
        state.picklistAggregateTotals = null;
      }
    } else {
      state.selectedDeliveryDetails = {};
      result = data;
    }
    state.deliveryPicklist = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setSelectedPicklistMap(state, data) {
    if (state.selectAllPicklistConsignees) {
      state.selectAllPicklistConsignees = false;
    }
    state.selectedPicklistMap = data;
  },
  setPicklistIdsMap(state, data) {
    state.picklistIdsMap = data;
  },
  setSelectAllPicklistConsignees(state, data) {
    state.selectAllPicklistConsignees = data;
  },
  setPicklistAggregateTotals(state, data) {
    state.picklistAggregateTotals = data;
  },
  setIndentAggregateTotals(state, data) {
    state.indentAggregateTotals = data;
  },
  setDeliveryIndentsPickList(state, data) {
    state.deliveryIndentsPickList = data;
  },
  setShowIndentTopupDrawer(state, data) {
    state.showIndentTopupDrawer = data;
  },
  setSplitObject(state, data) {
    state.splitObject = data;
  },
  setCombineObject(state, data) {
    state.combineObject = data;
  },
  setSplitOrderSelectedIndex(state, data) {
    state.splitOrderSelectedIndex = data;
  },
  setCombineOrderSelectedIndex(state, data) {
    state.combineOrderSelectedIndex = data;
  },
  setReturnContracts(state, data) {
    state.returnContracts = data;
  },
  setCombineAndSplitBtnDisable(state, data) {
    state.combineAndSplitBtnDisable = data;
  },
  setContractCollection(state, data) {
    state.contractCollection = data;
  },
  setSelectedDeliveryNumber(state, data){
    state.selectedDeliveryNumber ={...data};
  },
  setSelectedDeliveryDetails(state, data){
    state.selectedDeliveryDetails = {...data};
  },
  updateSingleSelection(state, { picklistId, isSelected, picklistData }) {
      if (isSelected) {
        state.selectedPicklistMap[picklistId] = true
      } else {
        delete state.selectedPicklistMap[picklistId]
      }

    if (isSelected) {
      if (!state.selectedPicklistIds.includes(picklistId)) {
        state.selectedPicklistIds.push(picklistId);
      }
      state.selectedPicklistData[picklistId] = picklistData;
    } else {
      state.selectedPicklistIds = state.selectedPicklistIds.filter(id => id !== picklistId);
      delete state.selectedPicklistData[picklistId];
    }
  },
  selectAllPicklists(state, picklistDataArray) {
    if (!picklistDataArray || picklistDataArray.length === 0) {
      state.selectedPicklistIds = [];
      state.selectedPicklistData = {};
      return;
    }
    state.selectedPicklistIds = picklistDataArray.map(p => getPicklistKey(p)).filter(Boolean);
    state.selectedPicklistData = picklistDataArray.reduce((acc, picklist) => {
      const key = getPicklistKey(picklist);
      if (key) {
        acc[key] = picklist;
      }
      return acc;
    }, {});
  },

  clearAllSelections(state) {
    state.selectedPicklistIds = [];
    state.selectedPicklistData = {};
    state.selectedPicklistMap = {};
    state.selectedDeliveryDetails = {};
    state.selectedDeliveryNumber = {};
    state.selectAllPicklistConsignees = false;
  },
  setSelectedIndentIds(state, data) {
    state.selectedIndentIds = data;
  },
  setSelectedIndentData(state, data) {
    state.selectedIndentData = data;
  },
  updateSingleIndentSelection(state, { indentId, isSelected, indentData }) {
    if (!state.selectedIndentMap) state.selectedIndentMap = {};
    if (!state.selectedIndentIds) state.selectedIndentIds = [];
    if (!state.selectedIndentData) state.selectedIndentData = {};
    const idKey = String(indentId);
    if (isSelected) {
      state.selectedIndentMap[idKey] = true;
      if (!state.selectedIndentIds.includes(idKey)) {
        state.selectedIndentIds.push(idKey);
      }
      state.selectedIndentData[idKey] = indentData && indentData.totals ? indentData : indentData || {};
    } else {
      state.selectedIndentMap[idKey] = false;
      state.selectedIndentIds = state.selectedIndentIds.filter(i => String(i) !== idKey);
      if (state.selectedIndentData && state.selectedIndentData[idKey]) {
        delete state.selectedIndentData[idKey];
      }
      delete state.selectedIndentMap[idKey];
      state.selectAll = false;
      state.indentAggregateTotals = null;
    }
  },
  selectAllIndents(state, indentDataArray) {
    if (!indentDataArray || indentDataArray.length === 0) {
      state.selectedIndentIds = [];
      state.selectedIndentData = {};
      state.selectedIndentMap = {};
      return;
    }
    state.selectedIndentIds = indentDataArray.map(i => i.id);
    state.selectedIndentData = indentDataArray.reduce((acc, indent) => {
      acc[indent.id] = indent;
      return acc;
    }, {});
    indentDataArray.forEach(indent => {
      state.selectedIndentMap[indent.id] = true;
    });
  },
  clearIndentSelections(state) {
    state.selectedIndentIds = [];
    state.selectedIndentData = {};
    state.selectedIndentMap = {};
    state.selectAll = false;
    state.indentAggregateTotals = null;
  },

};
export default mutation;
